import { render, staticRenderFns } from "./config_source_table.vue?vue&type=template&id=66a22d88&scoped=true&"
import script from "./config_source_table.vue?vue&type=script&lang=js&"
export * from "./config_source_table.vue?vue&type=script&lang=js&"
import style0 from "./config_source_table.vue?vue&type=style&index=0&id=66a22d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a22d88",
  null
  
)

export default component.exports